import { Component, Input } from '@angular/core';
import { ModalService } from '../../shared/service/modal.service';

const ARCHIVO_RECOMENDACIONES = 'assets/files/Recomendaciones de Seguridad en neocrédito.pdf';
const NOMBRE_ARCHIVO = 'Recomendaciones de Seguridad en neocrédito';
const EXTENSION_ARCHIVO = '.pdf';

export type FooterPublicVariant = 'legacy' | 'v2' | 'compact';

@Component({
  selector: 'app-footer-public',
  templateUrl: './footer-public.component.html',
  styleUrls: ['./footer-public.component.scss'],
  standalone: false,
})
export class FooterPublicComponent {
  /** Si es true, se muestra solo el logo de neocrédito (p. ej. en registro). Por defecto false. */
  @Input() showLogoOnly = false;

  @Input() variant: FooterPublicVariant = 'legacy';

  constructor(private readonly modalService: ModalService) {}

  abrirRecomendacionesSeguridad(): void {
    this.modalService.descargaModal(ARCHIVO_RECOMENDACIONES, NOMBRE_ARCHIVO, EXTENSION_ARCHIVO);
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    this.abrirRecomendacionesSeguridad();
  }
}
